import { isFunction } from 'lodash';

export default {
  /**
   * Set or remove a Firestore unbinding function
   * @param {import('firebase/firestore').Unsubscribe | null} unbindFunc - The unsubscription function
   * to store or null to remove
   * @param {string} bindingKey - The binding key in the format `storeName/propertyName`
   * (e.g., 'auth/associatedClients')
   */
  setFirestoreUnbinding(unbindFunc, bindingKey) {
    const existingUnbind = this.firestoreUnbindings[bindingKey];
    if (existingUnbind && isFunction(existingUnbind)) {
      existingUnbind();
    }

    if (existingUnbind !== undefined && !unbindFunc) {
      delete this.firestoreUnbindings[bindingKey];
      return;
    }

    if (unbindFunc !== null) {
      this.firestoreUnbindings[bindingKey] = unbindFunc;
    }
  },

  /**
   * Clear all Firestore unbindings (e.g. on logout)
   */
  clearAllUnbindings() {
    Object.values(this.firestoreUnbindings).forEach((unbindFunc) => {
      if (isFunction(unbindFunc)) {
        unbindFunc();
      }
    });
    this.firestoreUnbindings = {};
  },
};
